module.exports = "https://s91588.cdn.ngenix.net/news-frontend/_next/static/images/insurance-5e8eae1d95f6417f6483cef3b956a125.jpg";